/**
 * Formats a Date as the YYYY-MM-DD string an <input type="date"> expects,
 * using the browser's local calendar day.
 *
 * `toISOString()` converts to UTC first, so for a user east of UTC it returns
 * yesterday's date after local midnight (and tomorrow's for users west of UTC
 * late in the day). In a diary keyed on dates that silently files entries and
 * date ranges under the wrong day.
 */
export function toDateInputValue(date: Date): string {
  const year = date.getFullYear()
  const month = String(date.getMonth() + 1).padStart(2, '0')
  const day = String(date.getDate()).padStart(2, '0')

  return `${year}-${month}-${day}`
}
